/* Reused Dark-Academia legal-doc shell. Used by Terms + Privacy. */

export function LegalPage({ title, subtitle, section, children, testid }) {
  return (
    <div data-testid={testid} style={{ padding: "60px 6vw 100px", maxWidth: 880, margin: "0 auto" }}>
      <div className="overline" style={{ marginBottom: 14 }}>{section}</div>
      <h1 className="font-serif" style={{ fontSize: "clamp(40px, 5vw, 58px)", lineHeight: 1.05, marginBottom: 8 }}>
        {title}
      </h1>
      {subtitle && (
        <p className="font-serif" style={{ color: "var(--parchment-dim)", fontStyle: "italic", fontSize: 17, marginBottom: 36 }}>
          {subtitle}
        </p>
      )}
      <div className="rule-parchment" style={{ marginBottom: 36 }} />
      <div
        className="font-serif"
        style={{
          fontSize: 16, lineHeight: 1.8, color: "var(--parchment)",
          display: "flex", flexDirection: "column", gap: 22,
        }}
      >
        {children}
      </div>
      <div className="rule-parchment" style={{ marginTop: 56, marginBottom: 20 }} />
      <p className="font-mono" style={{ fontSize: 10, letterSpacing: "0.25em", color: "var(--muted)", textTransform: "uppercase" }}>
        Last updated · February 2026 · v1.0
      </p>
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <section>
      <h3 className="font-display" style={{ fontSize: 24, color: "var(--brass)", marginBottom: 10, fontStyle: "italic" }}>
        {n}. {title}
      </h3>
      <div style={{ color: "var(--parchment-dim)" }}>{children}</div>
    </section>
  );
}
